import { useEffect } from 'react'

const useKeyboardNavigation = ({ show, onClose, items, activeIndex, setActiveIndex, hasQuery, onSelect }) => {
  useEffect(() => {
    if (!show) return

    const totalItems = items.length

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose()
        return
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault()
        setActiveIndex(prev => (prev + 1) % totalItems)
        return
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault()
        setActiveIndex(prev => (prev - 1 + totalItems) % totalItems)
        return
      }

      if (event.key === 'Enter') {
        event.preventDefault()
        const selected = items[activeIndex]
        if (selected) {
          onSelect(hasQuery ? selected : { path: selected.path })
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [show, onClose, items, activeIndex, setActiveIndex, hasQuery, onSelect])
}

export default useKeyboardNavigation
